import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/inferior/defect/reason',
    name: 'inferiorDefectReasonGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
